<div style="position: relative;">
  <h2 mat-dialog-title>Editar perfil</h2>
  <button mat-icon-button class="close-button" (click)="dialogRef.close()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="modal-content-container">
    <div *ngIf="isLoading" class="loading-container">
        <mat-spinner [diameter]="50"></mat-spinner>
        <p class="loading-text">Cargando datos del perfil...</p>
    </div>

    <form class="row p-1" [formGroup]="form" *ngIf="!isLoading">
        <div class="col-12">
            <div class="row text-center">
                <div class="col-12">
                    <img mat-card-image [src]="this.profileImage" class="mx-auto d-block"
                        style="width: 200px; height: 200px; margin-left: 75px; border: solid; border-radius: 100px; margin-bottom: 10px;">
                </div>
                <div class="col-12">
                    <button mat-button color="primary" class="btn-size" (click)="fileInputProfile.click()">
                        <ng-container *ngIf="!isUploadingPhoto">
                            <span *ngIf="profileImage === null">{{ 'profile.uploadProfilePicture' | translate }}</span>
                            <span *ngIf="profileImage !== null">{{ 'profile.changeProfilePicture' | translate }}</span>
                        </ng-container>
                        <ng-container *ngIf="isUploadingPhoto">
                            <div class="d-flex align-items-center justify-content-center spinner-wht">
                                <mat-spinner [diameter]="20" class="button-spinner">
                                </mat-spinner>
                            </div>
                        </ng-container>
                    </button>
                </div>
                <div class="col-12">
                    <button mat-button color="accent" class="btn-size mt-2" (click)="openCamera()">
                        <mat-icon>camera_alt</mat-icon>
                        {{ 'profile.takePhoto' | translate }}
                    </button>
                </div>

                <!-- INPUT PARA SUBIR IMAGEN -->
                <input #fileInputProfile hidden type="file" name="AttachedFile" class="file-upload"
                    accept=".jpg,.jpeg,.png,image/jpeg,image/png" (change)="upload($event.target.files)">

                <!-- CAMARA -->
                <div class="col-12 mt-3 text-center">
                    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <video #videoElement hidden autoplay playsinline
                            style="width: 100%; max-width: 400px; padding-top: 10px; display: block; margin: 0 auto;">
                        </video>
                        <canvas #canvasElement hidden
                            style="width: 100%; max-width: 400px; display: block; margin: 0 auto;">
                        </canvas>
                    </div>

                    <!-- Camera controls -->
                    <div *ngIf="isCameraActive" class="camera-controls mt-3 text-center">
                        <button mat-raised-button color="primary" class="mr-2" [disabled]="isCapturingPhoto"
                            (click)="capturePhoto()">
                            <ng-container *ngIf="!isCapturingPhoto">
                                <mat-icon>camera</mat-icon>
                                {{ 'profile.capturePhoto' | translate }}
                            </ng-container>
                            <ng-container *ngIf="isCapturingPhoto">
                                <div class="d-flex align-items-center justify-content-center">
                                    <mat-spinner [diameter]="20" class="button-spinner mr-2"></mat-spinner>
                                    <span>{{ 'profile.processingPhoto' | translate }}</span>
                                </div>
                            </ng-container>
                        </button>
                        <button mat-raised-button color="warn" class="mt-2" [disabled]="isCapturingPhoto"
                            (click)="closeCamera()">
                            <mat-icon>close</mat-icon>
                            {{ 'profile.cancel' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row p-0" *ngIf="profile.IsIndividual">
                <div class="col-6 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Nombre</mat-label>
                        <input type="text" matInput formControlName="Name" required />
                        <mat-error *ngIf="form.controls['Name'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Segundo Nombre</mat-label>
                        <input type="text" matInput formControlName="SecondName" />
                    </mat-form-field>
                </div>

                <div class="col-6 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Apellido</mat-label>
                        <input type="text" matInput formControlName="LastName" required />
                        <mat-error *ngIf="form.controls['LastName'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-6 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Segundo Apellido</mat-label>
                        <input type="text" matInput formControlName="SecondLastName" />
                    </mat-form-field>
                </div>

                <div class="col-12 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Fecha de Nacimiento (dd/mm/aaaa)</mat-label>
                        <input type="text" matInput formControlName="BirthDate" placeholder="dd/mm/aaaa"
                               mask="00/00/0000" [dropSpecialCharacters]="false" [showMaskTyped]="false"
                               maxlength="10" />
                        <mat-error *ngIf="form.controls['BirthDate'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                        <mat-error *ngIf="form.controls['BirthDate'].hasError('invalidDate') && !form.controls['BirthDate'].hasError('required')">
                            Fecha inválida. Use el formato dd/mm/aaaa.
                        </mat-error>
                        <mat-error *ngIf="form.controls['BirthDate'].hasError('invalidDay') && !form.controls['BirthDate'].hasError('required')">
                            El día debe estar entre 01 y 31.
                        </mat-error>
                        <mat-error *ngIf="form.controls['BirthDate'].hasError('invalidMonth') && !form.controls['BirthDate'].hasError('required')">
                            El mes debe estar entre 01 y 12.
                        </mat-error>
                        <mat-error *ngIf="form.controls['BirthDate'].hasError('invalidYear') && !form.controls['BirthDate'].hasError('required')">
                            El año debe ser válido.
                        </mat-error>
                        <mat-error *ngIf="form.controls['BirthDate'].hasError('futureDate') && !form.controls['BirthDate'].hasError('required')">
                            La fecha no puede ser futura.
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-6 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Género</mat-label>
                        <mat-select formControlName="Gender">
                            <mat-option value="">Seleccionar</mat-option>
                            <mat-option *ngFor="let g of genderOptions" [value]="g.value">{{g.label}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Color de Ojos</mat-label>
                        <mat-select formControlName="EyeColor">
                            <mat-option value="">Seleccionar</mat-option>
                            <mat-option *ngFor="let c of eyeColors" [value]="c.value">{{c.label}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="col-12 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Peso (lbs)</mat-label>
                        <input type="number" matInput formControlName="Weight" placeholder="Peso en libras" min="50"
                            max="500" name="weight">
                    </mat-form-field>
                </div>

                <div class="col-6 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Altura - Pies</mat-label>
                        <mat-select formControlName="HeightFeet">
                            <mat-option [value]="3">3</mat-option>
                            <mat-option [value]="4">4</mat-option>
                            <mat-option [value]="5">5</mat-option>
                            <mat-option [value]="6">6</mat-option>
                            <mat-option [value]="7">7</mat-option>
                            <mat-option [value]="8">8</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6 mb-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Altura - Pulgadas</mat-label>
                        <mat-select formControlName="HeightInches">
                            <mat-option *ngFor="let inch of inches" [value]="inch">{{inch}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- Firma Digital (Solo lectura) -->
                <div class="col-12 mb-4" *ngIf="signatureImage">
                    <div class="signature-section">
                        <h4 class="signature-title">Firma Digital</h4>
                        <div class="signature-preview-container">
                            <img [src]="signatureImage" alt="Firma del solicitante" class="signature-image-readonly">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row p-0 form-group" *ngIf="!profile.IsIndividual">
                <div class="col-12">
                    <mat-form-field appearance="outline" *ngIf="!profile.IsIndividual">
                        <mat-label>Nombre</mat-label>
                        <input type="text" matInput formControlName="Name" required />
                        <mat-error *ngIf="form.controls['Name'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-12" *ngIf="profileTypes.length > 0">
                    <mat-form-field appearance="outline">
                        <mat-label>Tipo de Perfil</mat-label>
                        <mat-select formControlName="ProfileTypeId" required>
                            <mat-option *ngFor="let item of profileTypes" [value]="item.Id">
                                <span class="select-input">
                                    {{ item.Name }}
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.controls['ProfileTypeId'].hasError('required')">
                            Campo requerido.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="col-12">
            <hr>
        </div>

        <div class="col-12">
            <app-street-postal-address-form formControlName="Address"></app-street-postal-address-form>
        </div>
    </form>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" [disabled]="isUpdating">Cancelar</button>
    <button mat-flat-button color="primary" (click)="updateProfile()" [disabled]="isUpdating" class="btn-update">
        <div class="btn-content">
            <span [style.visibility]="isUpdating ? 'hidden' : 'visible'">Actualizar</span>
            <div class="spinner-wrapper" *ngIf="isUpdating">
                <mat-spinner [diameter]="20"></mat-spinner>
            </div>
        </div>
    </button>
</div>
